/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { useHeader } from '../../context/HeaderContext'; // Import the custom hook
import ActionItems from '../../components/pageComponents/dashboard/ActionItems';
import ActionItemCard from '../../components/pageComponents/dashboard/ActionItemCard';
import styles from '../../styles/components/pageComponents/dashboard/DashboardPrograms.module.css';
// ... other imports

import { ReactComponent as ResourcesIcon } from '../../assets/icons/resources.svg';
import { ReactComponent as SessionsIcon } from '../../assets/icons/workshop.svg';
import { ReactComponent as AssessmentsIcon } from '../../assets/icons/assessment.svg';

import { Button } from '@mui/material';
import { useDashboard } from '../../hooks/useDashboard';
import { useLearnerDashboardCounts } from '../../hooks/useLearnerDashboardCounts';
import DashboardPrograms from '../../components/pageComponents/dashboard/DashboardPrograms';

import { useUserProfile } from '../../hooks/useUserProfile';
import { useLearnerProfilePrograms } from '../../hooks/useCourse';
// import Dropdown from '../../components/controlVariations/DropdownProgram';
import MultiSelectDropdown from '../../components/controlVariations/Multiselectdropdowntoggle';


// import Dropdown from '../../components/controlVariations/Dropdown';

const Dashboard: React.FC = () => {
	const { dashboardData, isLoading, error, refreshDashboard } =
		useDashboard();
	const {
		profile,
		updateProfile,
		loading: profileLoading,
	} = useUserProfile();
	const learnerId = profile?.id || '';
	const { programs } = useLearnerProfilePrograms(learnerId);
	//     const {
	//     dashboardCounts,
	//     loading: dashboardCountsLoading,
	//     error: dashboardCountsError,
	// } = useLearnerDashboardCounts();

	const { setHeaderContent } = useHeader();

	const userDataString = localStorage.getItem('user');
	let userName = 'John';
	let roleName = 'Coachee';
	if (userDataString) {
		try {
			const userData = JSON.parse(userDataString);

			userName = userData.fullname.split(' ')[0];
			roleName = userData.rolename;
		} catch (error) {
			userName = 'John';
			roleName = 'Coachee';
		}
	} else {
		console.warn('No user data found in localStorage.');
		userName = 'John';
		roleName = 'Coachee';
	}

	const [selectedProgram, setSelectedProgram] = useState('');
	console.log('selectedProgram:', selectedProgram);

	const {
		dashboardCounts,
		loading: dashboardCountsLoading,
		error: dashboardCountsError,
	} = useLearnerDashboardCounts(selectedProgram);

	useEffect(() => {
		setHeaderContent(<p>Welcome back, {userName}</p>);

		return () => {
			setHeaderContent(null); // cleanup on unmount
		};
	}, [userName]);

	// 🔄 3. HANDLE LOADING AND ERROR STATES
	if (isLoading) {
		return <div>Loading...</div>;
	}

	if (error) {
		return (
			<div style={{ textAlign: 'center', padding: '40px' }}>
				<p style={{ color: 'red' }}>
					Failed to load dashboard data: {error}
				</p>
				<Button variant="contained" onClick={() => refreshDashboard()}>
					Try Again
				</Button>
			</div>
		);
	}

	const dropdownOptions =
		programs?.map((program: any) => ({
			label: program.title,
			value: program.id,
		})) || [];

		const truncateText = (text: string, maxLength = 20) => {
	if (!text) return '';

	return text.length > maxLength
		? `${text.slice(0, maxLength)}...`
		: text;
};
	return (
		<div>
			<div className={styles.dropdownWrapper}>
				<div className={styles.programLable}>Your Action Items</div>
				<div className={styles.dropdownWrapper2}>
					<span className={styles.dropdownlable}>program</span>

					{/* <Dropdown
						options={dropdownOptions}
						placeholder="Select Program"
						selected={truncateText(
		                 dropdownOptions.find(
		                  	option => option.value === selectedProgram
		                    )?.label || '',
	                    	34
                    	)}
						onSelect={value => setSelectedProgram(value)}
						width="100%"
						height="42px"
						variant="default"
					/> */}
					<MultiSelectDropdown
	options={dropdownOptions}
	placeholder="Select Program"
	selectedValues={selectedProgram ? [selectedProgram] : []}
	onChange={values => {
		setSelectedProgram(values[0] || '');
	}}
	width="100%"
	height="42px"
	selectedLabel="Program"
	singleSelect={true}
/>
				</div>
			</div>

			<ActionItems>
				<ActionItemCard
					type="resources"
					icon={<ResourcesIcon />}
					title="Resources"
					progressText={`${dashboardCounts?.summary?.resources?.downloaded ?? 0} Downloaded`}
				/>
				<ActionItemCard
					type="sessions"
					icon={<SessionsIcon />}
					title="Upcoming Activities"
					progressText={`${
						dashboardCounts?.summary?.activities.total || 0
					} Activities`}
				/>

				<ActionItemCard
					type="assessments"
					icon={<AssessmentsIcon />}
					title="Assignments Due"
					progressText={`${
						dashboardCounts?.summary?.assignments.completed || 0
					}/${
						dashboardCounts?.summary?.assignments.total || 0
					} Completed`}
				/>
			</ActionItems>

			<div style={{ marginTop: '54px' }}>
				
				<DashboardPrograms learnerId={profile?.id || ''} />
			</div>
		</div>
	);
};

export default Dashboard;
